// import {HackTimer} from "hacktimer/HackTimer";
import { Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Chart from 'chart.js/auto';
import { map } from 'rxjs/operators';
import { CommonService } from 'src/app/common.service';
import { TimerService } from 'src/app/timer.service';
import { focus } from 'src/app/animation';
import { ConnectionTrackerService } from 'src/app/connection-tracker.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { CloseTimerConfirmationComponent } from 'src/app/dialog/close-timer-confirmation/close-timer-confirmation.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-fullscreen-timer',
  standalone: false,
  templateUrl: './fullscreen-timer.component.html',
  styleUrl: './fullscreen-timer.component.css',
  animations: [
    focus
  ]
})
export class FullscreenTimerComponent implements OnInit, OnDestroy {
  load: boolean = false;
  processing: boolean = false;
  timerPaused: boolean = true;
  blkOut: boolean = false;
  error: any;
  isChecked = true;
  showInnerView: boolean = false;
  title = 'ng-chart';
  chart: any = [];
  gridsize: number = 30;
  myColorVaraible: any;
  timerid: string;
  someValue = 0;
  color: 'yellow';
  classToggled = false;
  toprightclass = false;
  startValue: number = 80;
  startThumb: any;
  logoPosition: any;
  timerDetails: any = [];
  black = 0 * 60;
  green = 7 * 60;
  yellow = 2 * 60;
  red = 1 * 60;
  downloadTimer: any;
  timevalue = 10 * 60;
  duration: number = 600;
  durationOnStart: number = 0;
  lapsedOnStart: number = 0;
  startTime: number = 0;
  focusMessage: any
  focusTimer: any
  speakerMessage: string = '';
  messageState: string = 'invisible';
  timerState: string = 'visible';
  is_focus: boolean = true;
  hideTimer: boolean = false;
  minutes: number = 0;
  seconds: number = 0;
  syncInterval: any;
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  @ViewChild('output') output!: ElementRef;
  systemBrowserId: string | null = null;
  tabId: string | null = null;
  heartbeatInterval:any;
  constructor(private router: Router,public dialog: MatDialog, private renderer: Renderer2, private route: ActivatedRoute, private _snackBar: MatSnackBar, private dataservice: CommonService, private timerService: TimerService,private trackingService: ConnectionTrackerService) {
    this.timerid = this.route.snapshot.paramMap.get('timerid');
    this.loadTimer();
  }
  loadTimer() {
    this.dataservice.getData('/api/public-timer/' + this.timerid).subscribe({
      next: (timer: any) => {
        this.timerDetails = timer;
        this.duration = this.timerDetails.duration;
        this.startTime = new Date(this.timerDetails.start_at).getTime();
        this.durationOnStart = this.duration;
        this.lapsedOnStart = parseFloat(this.timerDetails.lapsed_time ?? 0);
        if (this.timerDetails.current_message) {
          this.speakerMessage = this.timerDetails.current_message;
          this.messageState = 'visible';
          setTimeout(() => {
            this.renderer.setProperty(this.output.nativeElement, 'innerHTML', this.timerDetails.current_message);
            this.renderer.setStyle(this.output.nativeElement, 'fontSize', '2.4rem');
            this.resizeToFit();
          }, 100);
        }
        if (this.duration + this.lapsedOnStart < 0) {
          this.lapsedOnStart = -1 * this.duration;
          this.timerDetails.lapsed_time = this.lapsedOnStart;
          this.timerDetails.is_running = 0;
          this.pauseOvertimer();
        }
        if (this.timerDetails.is_running) {
          const startTime = new Date(this.timerDetails.start_at).getTime();
          const elapsedTime = (Date.now() - startTime) / 1000;
          this.timevalue = this.duration + parseFloat(this.timerDetails.lapsed_time ?? 0) - elapsedTime;
          this.setRemainingTimeValue(this.duration, (parseFloat(this.timerDetails.lapsed_time ?? 0) < 0 ? -1 * parseFloat(this.timerDetails.lapsed_time ?? 0) + elapsedTime : elapsedTime));
          this.startimer();
        } else if (this.timerDetails.is_paused) {
          this.timevalue = this.duration + parseFloat(this.timerDetails.lapsed_time ?? 0);
          this.setRemainingTimeValue(this.duration, -1 * parseFloat(this.timerDetails.lapsed_time ?? 0));
          this.updateMinutesAndSec();
        } else {
          this.setTimeValue((this.duration + parseFloat(this.timerDetails.lapsed_time ?? 0)) < 0 ? 0 : this.duration + parseFloat(this.timerDetails.lapsed_time ?? 0));
          this.updateMinutesAndSec();
        }
        this.load = true;
        this.registerDevice();
      },
      error: (error) => {
        if (error.status === 401) {
          this.load = false;
          this.dataservice.tokenExpireLogout();
        } else {
          this.error = error;
        }
      }
    });
  }

  private registerDevice() {
    this.tabId = this.trackingService.getTabId();
    if (!this.tabId) { return; }
    const deviceData = { timer_id: this.timerid, device_id: this.tabId };
    this.dataservice.sendPostRequest('/api/devices', deviceData).subscribe({
      error: (error) => console.warn('Device registration failed:', error.status)
    });
  }
  formatLabel(value: number): string {
    if (value >= 1) {
      return Math.round(value / 1) + '%';
    }

    return `${value}`;
  }
  resizeToFit() {
    let fontSize = parseFloat(window.getComputedStyle(this.output.nativeElement).fontSize);
    this.renderer.setStyle(this.output.nativeElement, 'fontSize', `${fontSize - 1}px`);
    console.log(this.output.nativeElement.clientHeight);
    // Check if the text is overflowing
    if (this.output.nativeElement.clientHeight >= 400) {
      this.resizeToFit(); // Recursive call until text fits
    }
  }
  setTimerForPause(isPaused,duration,lapsed_time){
    if (isPaused) {
      this.duration = duration;
      this.timerDetails.lapsed_time = parseFloat(lapsed_time ?? 0);
      this.timevalue = this.duration + parseFloat(this.timerDetails.lapsed_time);

      console.log('Timevalue', this.timevalue, this.duration, parseFloat(this.timerDetails.lapsed_time));
      this.setRemainingTimeValue(this.duration, -1 * parseFloat(this.timerDetails.lapsed_time));
    } else {
      this.setTimeValue((this.duration + parseFloat(this.timerDetails.lapsed_time)) < 0 ? 0 : this.duration + parseFloat(this.timerDetails.lapsed_time));
    }
    this.updateMinutesAndSec();
  }
  ngOnInit() {
    this.logoPosition = 'topLeft';
    this.chart = new Chart('customtimer', {
      type: 'pie',
      data: {
        labels: ['Black', 'Green', 'Yellow', 'Red'],
        datasets: [
          {
            label: '# of Votes',
            data: [this.black, this.green, this.yellow, this.red],
            backgroundColor: [
              '#000000',
              '#00A254',
              '#E2D900',
              '#E20000'
            ],
            borderWidth: 0,
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false
          },
        },
        cutout: '90%',
      },
    });

    this.timerService.listenForTimerStart((data: any) => {
      console.log(data);
      if (String(data.timerId) === String(this.timerid)) {
        this.startTime = new Date(data.startTime).getTime();
        this.durationOnStart = data.duration;
        // this.lapsedOnStart = Math.floor(data.lapsed);
        this.lapsedOnStart = parseFloat(data.lapsed ?? 0);
        console.log('NOW Start timer', this.lapsedOnStart);
        this.timerPaused = false;
        this.timerDetails.is_paused = 0;
        this.timerDetails.is_running = 1;
        if (data.lapsed == 0) {
          this.startimer();
        } else {
          // this.setRemainingTimeValue(data.duration, -1 * Math.floor(data.lapsed));
          this.setRemainingTimeValue(data.duration, -1 * parseFloat(data.lapsed));
          this.startimer();
        }
        /* this.syncInterval = setTimeout(() => {
          this.loadTimer();
        }, 3000); */
      }
    });
    this.timerService.listenForTimerPause((data: any) => {
      console.log(data);
      if (String(data.timerId) === String(this.timerid)) {
        console.log('NOW Pause timer',data,-1 * data.lapsed);
        this.timerPaused = true;
        this.timerDetails.is_paused = 1;
        this.timerDetails.is_running = 0;
        // this.setRemainingTimeValue(data.duration, -1 * Math.floor(data.lapsed));
        this.setRemainingTimeValue(data.duration, -1 * parseFloat(data.lapsed));
        clearInterval(this.downloadTimer);
        this.setTimerForPause(true,data.duration,data.lapsed);
        // this.loadTimer();
      }
    });
    this.timerService.listenForMessage((data: any) => {
      console.log(data);
      if (String(data.timerid) === String(this.timerid)) {
        let thisvar = this;
        this.speakerMessage = data.message;
        this.renderer.setProperty(this.output.nativeElement,'innerHTML',data.message);
        this.renderer.setStyle(this.output.nativeElement,'fontSize','2.4rem');
        this.messageState = 'visible';
        setTimeout(function(){
          thisvar.resizeToFit();
        },500);
      }
    });
    this.timerService.listenForFlashBlackout((data: any) => {
      console.log(data);
      let flashEnabled = false;
      let thisvar = this;
      if (String(data.timerid) === String(this.timerid)) {
        if (data.flash) {
          flashEnabled = true;
          this.focusMessage = setInterval(() => {
            console.log(this.messageState);
            this.messageState = (this.messageState == 'visible' ? 'invisible' : 'visible');
          }, 500);
        } else {
          clearInterval(this.focusMessage);
          this.messageState = 'invisible';
          this.speakerMessage = '';
        }
      }
      setTimeout(function () {
        if (flashEnabled) {
          clearInterval(thisvar.focusMessage);
          thisvar.messageState = 'visible';
        }
      }, 5000);
    });

    this.timerService.listenForTimerFlashBlackout((data: any) => {
      let timerflashEnabled = false;
      let thisvar = this;
      if (String(data.timerid) === String(this.timerid)) {
        if (data.flash) {
          timerflashEnabled = true;
          this.focusTimer = setInterval(() => {
            console.log(this.timerState);
            this.timerState = (this.timerState == 'visible' ? 'invisible' : 'visible');
          }, 500);
        } else {
          clearInterval(this.focusTimer);
          this.timerState = 'invisible';
        }
      }
      setTimeout(function () {
        if (timerflashEnabled) {
          clearInterval(thisvar.focusTimer);
          thisvar.timerState = 'visible';
        }
      }, 5000);
    });
    this.timerService.listenForFocusMsg((data: any) => {
      console.log(data);
      if (String(data.timerid) === String(this.timerid)) {
        if (data.focus) {
          this.is_focus = false;
          this.hideTimer = !this.is_focus;
        } else {
          this.is_focus = true;
          this.hideTimer = !this.is_focus;
        }
      }
    });
    this.timerService.listenForDevices((data: any) => {
      console.log('DEVICES');
      console.log(data);
      if (String(data.timerid) === String(this.timerid) && data.deviceid == this.tabId && data.addremove == 0) {
        this.router.navigate(['thank-you']);
      }
    });
    this.timerService.listenForDevicesReload((data: any) => {
      console.log('DEVICES RELOAD');
      console.log(data);
      if (String(data.timerid) === String(this.timerid) && data.deviceid == this.tabId) {
        window.location.reload();
      }
    });
    this.timerService.listenForAddMinusTime((data: any) => {
      console.log('Add Minus Time');
      console.log(data);
      console.log('DURATION 0',this.duration);
      if (String(data.timerid) === String(this.timerid)) {
        this.duration = this.duration+data.time;
        this.adjustTimer();
      }
    });
    this.timerService.listenForTotalBlackout((data: any) => {
      console.log('Total Blackout');
      console.log(data);
      if (String(data.timerid) === String(this.timerid)) {
        this.blkOut = data.blackout;
      }
    });
    this.timerService.listenForTimerReset((data: any) => {
      console.log('Timer Reset', data);
      if (String(data.timerId) === String(this.timerid)) {
        clearInterval(this.downloadTimer);
        this.timerPaused = true;
        this.timerDetails.is_running = 0;
        this.timerDetails.is_paused = 0;
        this.timerDetails.lapsed_time = 0;
        this.duration = data.duration;
        this.durationOnStart = data.duration;
        this.lapsedOnStart = 0;
        this.timevalue = data.duration;
        this.setTimeValue(data.duration);
        this.updateMinutesAndSec();
      }
    });
    this.startHeartbeat();
  }
  startHeartbeat() {
    this.heartbeatInterval = setInterval(() => {
      const data = {
        timerId: this.timerid,
        tabId: this.trackingService.getTabId()
      };
      this.dataservice.sendPostRequest('/api/heartbeat', data).pipe(
        map((res: Response) => (res)))
        .subscribe(
          (response) => {
            console.log(response);
            this.adjustTimer();
          },
          (error) => {
            console.log(error);
          }
        );
    }, 10000); // Every 10 seconds
  }
  updateMinutesAndSec() {
    const tv = isNaN(this.timevalue) ? 0 : Math.max(0, this.timevalue);
    this.minutes = Math.floor(tv / 60) % 60;
    this.seconds = Math.floor(tv % 60);
  }
  startimer() {
    clearInterval(this.downloadTimer);
    this.downloadTimer = setInterval(() => {
      const elapsedTime = (Date.now() - this.startTime) / 1000;
      this.timevalue = this.durationOnStart + this.lapsedOnStart - elapsedTime;
      const lapsedForChart = this.lapsedOnStart < 0 ? (-this.lapsedOnStart + elapsedTime) : elapsedTime;
      this.setRemainingTimeValue(this.durationOnStart, lapsedForChart);
      this.updateMinutesAndSec();
      this.dataservice.chartglobal = this.chart;
      if (this.timevalue < 1) {
        clearInterval(this.downloadTimer);
      }
    }, 1000);
  }
  setTimeValue(duration) {
    this.timevalue = duration;
    this.green = this.timevalue * 0.7;
    this.yellow = this.timevalue * 0.2;
    this.red = (this.timevalue - (this.green + this.yellow));
    clearInterval(this.downloadTimer);
    this.chart.data.datasets[0].data[0] = 0;
    this.chart.data.datasets[0].data[1] = this.green;
    this.chart.data.datasets[0].data[2] = this.yellow;
    this.chart.data.datasets[0].data[3] = this.red;
    this.chart.update();
  }
  setRemainingTimeValue(duration, lapsed) {
    this.black = lapsed;
    let preGreen = duration * 0.7;
    let preYellow = duration * 0.2;
    let preRed = (duration - (preGreen + preYellow));
    this.green = (preGreen - lapsed < 0 ? 0 : preGreen - lapsed);
    this.yellow = (preGreen - lapsed < 0 ? ((preGreen + preYellow) - lapsed < 0 ? 0 : (preGreen + preYellow) - lapsed) : preYellow);
    this.red = ((preGreen + preYellow) - lapsed < 0 ? ((duration) - lapsed < 0 ? 0 : duration - lapsed) : preRed);
    this.chart.data.datasets[0].data[0] = lapsed;
    this.chart.data.datasets[0].data[1] = this.green;
    this.chart.data.datasets[0].data[2] = this.yellow;
    this.chart.data.datasets[0].data[3] = this.red;
    this.chart.update();
  }
  syncTimer() {
    this.dataservice.getData('/api/public-timer/' + this.timerid).pipe(
      map((res: Response) => (res)))
      .subscribe(
        (response) => {
          console.log(response);
          this.timerDetails = response;
          this.duration = this.timerDetails.duration;
          if (this.timerDetails.is_running) {
            const startTime = new Date(this.timerDetails.start_at).getTime();
            const elapsedTime = (Date.now() - startTime) / 1000;
            console.log('Start Elapsed', startTime, elapsedTime);
            this.timevalue = this.duration - elapsedTime;
            console.log(this.timevalue);
            // this.setRemainingTimeValue(this.duration, Math.floor(this.timerDetails.lapsed_time > 0 ? this.timerDetails.lapsed_time : elapsedTime));
            this.setRemainingTimeValue(this.duration, parseFloat(this.timerDetails.lapsed_time??0) > 0 ? parseFloat(this.timerDetails.lapsed_time??0) : elapsedTime);
          } else if (this.timerDetails.is_paused) {
            // this.timevalue = this.duration - Math.floor(this.timerDetails.lapsed_time);
            this.timevalue = this.duration - parseFloat(this.timerDetails.lapsed_time??0);
            console.log('Timevalue', this.timevalue, this.duration, this.timerDetails.lapsed_time);
            // this.setRemainingTimeValue(this.duration, Math.floor(this.timerDetails.lapsed_time));
            this.setRemainingTimeValue(this.duration, parseFloat(this.timerDetails.lapsed_time??0));
          } else {
            this.setTimeValue((this.duration + this.timerDetails.lapsed_time??0) < 0 ? 0 : this.duration + this.timerDetails.lapsed_time??0);
            this.updateMinutesAndSec();
          }
          this.load = true;
        },
        (error) => {
          if (error.status === 401) {
            this.load = false;
            this.dataservice.tokenExpireLogout();
          } else {
            this.error = error;
          }
        });
  }
  removeDevice(){
    this.tabId = this.trackingService.getTabId();
    if (navigator.sendBeacon) {
      this.dataservice.deleteData('/api/devices/'+ this.tabId).pipe(
        map((res: Response) => (res)))
        .subscribe(
          (response) => {
            console.log(response);
          },
          (error) => {
            console.log(error);
          });
      console.log("Sent using sendBeacon");
    } else {
    this.dataservice.deleteData('/api/devices/'+ this.tabId).pipe(
        map((res: Response) => (res)))
        .subscribe(
          (response) => {
            console.log(response);
          },
          (error) => {
            console.log(error);
          });
        }
  }
  /* @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    alert('ABC');
    this.removeDevice();
    event.preventDefault();
  } */
  @HostListener('document:visibilitychange', ['$event'])
  visibilitychange() {
    this.checkHiddenDocument();
  }

  @HostListener('window:focus', ['$event'])
  onWindowFocus() {
    this.checkHiddenDocument();
  }

  checkHiddenDocument() {
    if (!document.hidden) {
      // Snap display to correct time immediately using stored startTime — no network needed
      if (!this.timerPaused && this.startTime) {
        const elapsedTime = (Date.now() - this.startTime) / 1000;
        this.timevalue = this.durationOnStart + this.lapsedOnStart - elapsedTime;
        this.startimer();
      }
      // Full server sync in background — catches remote pause/switch while screen was off
      this.loadTimer();
    }
  }
  closeScreen(){
    const dialogRef = this.dialog.open(CloseTimerConfirmationComponent, {
      width: '500px',
      panelClass: 'del-campaign-modal',
      backdropClass: 'gblbackdrop',
      data: { id: this.tabId, message: 'Are you sure you want to close this screen?' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== undefined) {
        this.router.navigate(['thank-you']);
      }
    });
  }
  ngOnDestroy() {
    clearInterval(this.heartbeatInterval);
    let thisvar = this;
    setTimeout(function(){

      thisvar.tabId = thisvar.trackingService.getTabId();
      thisvar.dataservice.deleteData('/api/devices/'+ thisvar.tabId).pipe(
        map((res: Response) => (res)))
        .subscribe(
          (response) => {
            console.log(response);
          },
          (error) => {
            console.log(error);
            /* thisvar.processing = false;
            if (error.status === 401) {
              thisvar.error = error.error.error_message;
  
              thisvar._snackBar.open(this.error, '', {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
              });
              // this.openSnackBar(error.error.error_message,'Dismiss');
            } else {
              let err = error.error;
              Object.keys(err).forEach(key => {
                Object.keys(err[key]).forEach(key1 => {
                  thisvar._snackBar.open(err[key][key1][0], '', {
                    duration: 3000,
                    horizontalPosition: thisvar.horizontalPosition,
                    verticalPosition: thisvar.verticalPosition,
                  });
                });
              });
            } */
          });
    },500);
  }
  adjustTimer(){
    console.log('DURATION',this.duration,this.timerDetails);
    if (this.timerDetails.is_running) {
      const startTime = this.startTime;
      const elapsedTime = (Date.now() - startTime) / 1000;
      console.log('Adjust Start Elapsed',this.duration, startTime, elapsedTime);
      this.timevalue = this.duration + parseFloat(this.timerDetails.lapsed_time??0) - elapsedTime;
      console.log(this.timevalue);
      this.setRemainingTimeValue(this.duration, (parseFloat(this.timerDetails.lapsed_time??0) < 0 ? -1 * parseFloat(this.timerDetails.lapsed_time??0) + elapsedTime : elapsedTime));
    } else if (this.timerDetails.is_paused) {
      this.timevalue = this.duration + parseFloat(this.timerDetails.lapsed_time??0);
      console.log('Adjust Timevalue', this.timevalue, this.duration, parseFloat(this.timerDetails.lapsed_time??0));
      this.setRemainingTimeValue(this.duration, -1 * parseFloat(this.timerDetails.lapsed_time??0));

      this.updateMinutesAndSec();
    } else {
      this.setTimeValue((this.duration + parseFloat(this.timerDetails.lapsed_time??0)) < 0 ? 0 : this.duration + parseFloat(this.timerDetails.lapsed_time??0));
      this.updateMinutesAndSec();
    }

  }
  pauseOvertimer() {
    const data = {
      timerId: this.timerid,
      current_time: new Date().toISOString()
    };
    this.dataservice.sendPostRequest('/api/pause-over-timer', data).pipe(
      map((res: Response) => (res)))
      .subscribe(
        (response) => {
          console.log(response);
          this.adjustTimer();
        },
        (error) => {
          console.log(error);
        }
      );
  }
}

export interface closeTimerData {
  id: string;
  message: string;
}